import { useState } from 'react';
import { Close } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { QuickBuy } from '@nerdunited-switch/switchpay-components';

const QuickBuyWrapper = ({ handleClosingModalCallBack }) => {
  const [showNotice, setShowNotice] = useState(true);

  if (showNotice) {
    return (
      <Dialog
        fullScreen={false}
        open
        onClose={handleClosingModalCallBack}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="responsive-dialog-title">
          Notice before starting
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClosingModalCallBack}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <Close />
        </IconButton>
        <DialogContent>
          <DialogContentText>
            Please copy your wallet address before starting this process. You&apos;ll need
            it later, and you won’t be able to go back once you begin. If you forget,
            you&apos;ll have to restart the entire flow. Once copied, click the button
            below to begin.
          </DialogContentText>
        </DialogContent>
        <DialogContent>
          <Button
            onClick={() => {
              setShowNotice(false);
            }}
            variant="contained"
            fullWidth
          >
            Begin
          </Button>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <QuickBuy
      companyHeaderId={process.env.NEXT_PUBLIC_SWITCHPAY_COMPANY_HEADER_ID}
      environment={process.env.NEXT_PUBLIC_SWITCHPAY_ENVIRONMENT}
      handleClosingModalCallBack={handleClosingModalCallBack}
    />
  );
};

export default QuickBuyWrapper;
